<template>
  <!-- id="bankdetails-layout" -->
  <div class="py-2 h-100">
    <section
      v-if="
        submittedSuccessfully &&
        !isError5 &&
        !isError2 &&
        pageStatus == PAGESTATUS_SUCCESS
      "
      class="alert-success elevation-0"
    >
      <SuccessComponent
        :title="$t('compensation.compensationAccepted')"
      ></SuccessComponent>
      <div class="text-success">
        <p>{{ $t("bankDetailsRefunds.success") }}</p>
      </div>
    </section>
    <v-container
      v-if="
        pageStatus == PAGESTATUS_FORM &&
        !isError2 &&
        !isError5 &&
        !submittedSuccessfully
      "
    >
      <ValidationObserver ref="obs" v-slot="{ invalid, dirty }">
        <h1 class="text-sm-left">{{ $t("bankDetails.titleFormB") }}</h1>
        <div class="text-bank-details d-flex flex-column">
          <DynamicForm
            ref="formMonetary"
            :values="defaultValues"
            :show-file-uploader="false"
            @form-ready="onDynamicFormReady"
            @form-validity="onFormValidityFile"
            @reset-file-validity="onDynamicFormReset"
          />
          <v-btn
            class="btn-bank pa-5"
            :disabled="!isDynamicFormReady || !dirty || invalid"
            @click="submit"
          >
            {{ $t("bankDetails.submit") }}</v-btn
          >
          <p class="confirm-bank text-center">
            {{ $t("bankDetails.confirmbank") }}
          </p>
        </div>
      </ValidationObserver>
    </v-container>

    <BankDetailsSapErrors
      :open="bankDetailsSapErrorsDialog.open"
      @close="bankDetailsSapErrorsDialogToggle"
      :errors="bankDetailsSapErrorsDialog.errors"
    />

    <ErrorInfoDBC
      v-if="isError2"
      class="alert-component"
      :title="$t('error_dbc.title2')"
      :subtitle="$t('bankDetailsRefunds.alreadyUpdated')"
    />
    <ErrorDBC
      v-if="isError5"
      class="alert-component"
      :title="$t('bankDetailsRefunds.title1')"
      :subtitle="$t('bankDetailsRefunds.title2')"
    />
  </div>
</template>

<script>
import Vuelidate from "vuelidate";
import BankDetailsSapErrors from "../dialogs/BankDetailsSapErrors.vue";
import Vue from "vue";
// import Layout from "@/components/Layout";
import DynamicForm from "@/components/bankdetails/BankDetailsDynamicForm.vue";
import { ValidationObserver } from "vee-validate";
// import { loadLanguageAsync } from "../../i18n/translation";
import Api from "@/api/api.js";
import { mapActions, mapStores } from "pinia";
import { useCountriesStore } from "@/stores/countriesStore";
import { useLanguageStore } from "@/stores/languageStore";
import { useTokenStore } from "@/stores/tokenStore";
import { useUiStore } from "@/stores/uiStore";
import ErrorDBC from "@/components/newCompensation/ErrorDBC.vue";
import ErrorInfoDBC from "@/components/newCompensation/ErrorInfoDBC.vue";
import SuccessComponent from "@/components/newCompensation/SuccessComponent.vue";

Vue.use(Vuelidate);

export default {
  name: "BankDetailsForm",
  components: {
    // Layout,
    BankDetailsSapErrors,
    DynamicForm,
    ValidationObserver,
    ErrorDBC,
    ErrorInfoDBC,
    SuccessComponent,
  },
  computed: {
    ...mapStores(useCountriesStore, useTokenStore, useLanguageStore),
    $crmEmailRefunds() {
      return "aireuropaon.refunds@aireuropa.com";
    },
  },
  created() {
    this.changeSpinner(true);
    try {
      this.rawToken = this.$route.params.token;
      const decoded = JSON.parse(atob(this.$route.params.token));
      this.tokenData = decoded;
      this.currency = decoded.currency;
      this.languageStore.changeLanguage(decoded.language || "en");
      this.initForm();
    } catch (e) {
      this.changeSpinner(false);
      this.pageStatus = this.PAGESTATUS_LOADERROR;
    }
  },
  data: () => ({
    defaultValues: null,
    PAGESTATUS_FORM: 0,
    PAGESTATUS_SUCCESS: 1,
    PAGESTATUS_LOADERROR: 2,
    PAGESTATUS_SUBMITERROR: 3,
    PAGESTATUS_CUSTOMERROR: 4,
    PAGESTATUS_CASECLOSED: 5,
    PAGESTATUS_CASEONGOING: 6,
    PAGESTATUS_EXPIRED: 7,
    pageStatus: null,
    currencyCountries: null,
    accountCurrency: null,
    tokenData: null,
    rawToken: null,
    currency: null,
    bankDetailsSapErrorsDialog: {
      open: false,
      errors: [],
    },
    uploadResponse: null,
    isError149: false,
    isError2: false,
    isError5: false,
    isFormValidFile: false,
    isDynamicFormReady: false,
    submittedSuccessfully: false,
  }),
  methods: {
    ...mapActions(useUiStore, ["changeSpinner"]),
    onDynamicFormReady() {
      this.isDynamicFormReady = true;
    },
    onDynamicFormReset() {
      this.isDynamicFormReady = false;
      this.isFormValidFile = false;
    },
    onFormValidityFile(isValid) {
      this.isFormValidFile = isValid;
    },
    notErrorScreen() {
      this.isError2 = false;
      this.isError5 = false;
    },
    async initForm() {
      try {
        const lang = this.tokenData?.language || "en";
        this.defaultValues = {
          AccountCurrency: this.currency,
          accountCurrency: this.currency,
        };
        await this.countriesStore.loadCountriesByCurrency(this.currency, lang);
        this.pageStatus = this.PAGESTATUS_FORM;
        this.changeSpinner(false);
      } catch (e) {
        this.changeSpinner(false);
        this.pageStatus = this.PAGESTATUS_LOADERROR;
      }
    },
    bankDetailsSapErrorsDialogToggle() {
      this.bankDetailsSapErrorsDialog.open =
        !this.bankDetailsSapErrorsDialog.open;
    },
    resetForm() {
      this.$refs.formMonetary.resetForm();
      this.$nextTick(() => {
        this.$refs.obs.reset();
      });
    },
    hasSapErrors(sapErrors) {
      if (!sapErrors) return;
      const errors = sapErrors.map((e) => {
        if (e?.Description) return e?.Description;
        return this.$te("errorsSap." + e.Code)
          ? this.$t("errorsSap." + e.Code)
          : null;
      });
      this.bankDetailsSapErrorsDialog = {
        open: true,
        errors,
      };
    },
    setCustomError({ errorCode, customError = "errorsSap.TPY-0100" }) {
      let error = "";
      if (!errorCode && customError) {
        error = customError;
      }
      if (errorCode) {
        let status = errorCode.toString();
        if (status.match(/^5\d{2}$/)) status = "5XXC";
        error = `error.error${status}`;
        if (!this.$te(error)) error = customError;
      }
      this.uiStore.setError({
        message: this.$t(error),
      });
    },
    async submit() {
      let body = this.$refs.formMonetary.dataForSend;
      if (body["IBAN"]) body["IBAN"] = body["IBAN"].toUpperCase();
      body["AccountCurrency"] = this.currency;
      body["AccountCurrency"] = this.currency;

      try {
        this.changeSpinner(true);

        const fullNameRaw = (
          this.tokenData?.fullName ||
          this.tokenData?.name ||
          ""
        )
          .toString()
          .trim();
        const [name = "", ...surnameParts] = fullNameRaw
          ? fullNameRaw.split(/\s+/)
          : [""];
        const surname =
          this.tokenData?.surname ||
          this.tokenData?.lastName ||
          surnameParts.join(" ") ||
          "";

        const payload = {
          // Campos bancarios dinámicos tal cual llegan de databankform
          ...body,
          // Metadatos del flujo RFSV
          token: this.tokenData?.token || this.rawToken,
          locata: this.tokenData?.locata || this.tokenData?.pnr,
          ticket: this.tokenData?.ticket || this.tokenData?.emd,
          amount:
            this.tokenData?.amount != null
              ? String(this.tokenData.amount)
              : undefined,
          flightDate:
            this.tokenData?.flightDate ||
            this.tokenData?.flight_date ||
            this.tokenData?.flightDateVal,
          origin: this.tokenData?.origin,
          destination: this.tokenData?.destination,
          flightNumber: this.tokenData?.flightNumber || this.tokenData?.flight,
          name,
          surname,
          fullName:
            this.tokenData?.fullName ||
            [name, surname].filter(Boolean).join(" "),
          email: this.tokenData?.email,
          language: this.tokenData?.language,
          // Se envía en ambos formatos para compatibilidad
        };

        const { data } = await Api.rfsvPaymentGenerate(payload);
        const statusCode = String(data?.StatusCode || "");

        if (statusCode === "0") {
          this.notErrorScreen();
          this.submittedSuccessfully = true;
          this.pageStatus = this.PAGESTATUS_SUCCESS;
        } else if (statusCode === "2") {
          this.notErrorScreen();
          this.submittedSuccessfully = false;
          this.isError2 = true;
        } else if (statusCode === "5") {
          this.notErrorScreen();
          this.submittedSuccessfully = false;
          this.isError5 = true;
        } else if (statusCode === "10") {
          this.notErrorScreen();
          this.hasSapErrors(data?.ErrorsSAP);
          this.submittedSuccessfully = false;
          this.pageStatus = this.PAGESTATUS_FORM;
        } else {
          this.changeSpinner(false);
          return;
        }
        this.changeSpinner(false);
      } catch (error) {
        console.error({ error });
        this.changeSpinner(false);
        // Cualquier error HTTP del POST (status != 200) muestra pantalla de error 5.
        this.notErrorScreen();
        this.isError5 = true;
      }
    },
  },
};
</script>

<!-- <style src="./BankDetails.css" scoped></style> -->

<style type="scss" scoped>
.text-bank-details {
  background-color: #fafafa;
  padding: 28px;
  margin-top: 22px;
  border-radius: 10px;
}
.confirm-bank {
  font-size: small;
  max-width: 1280px;
  margin-top: 8px;
}
.h-100 {
  height: 100%;
}
.alert-component {
  margin: 12em !important;
  display: flex;
  justify-content: center;
}
.alert-component {
  margin: 12em !important;
  display: flex;
  justify-content: center;
}

.alert-success {
  width: fit-content;
  box-shadow: 0px 5px 10px rgba(204, 204, 204, 0.3);
  padding: 50px;
  border-radius: 20px;
  margin: 5em auto;
  @media (max-width: 768px) {
    padding: 30px;
  }
  @media (max-width: 480px) {
    padding: 20px;
  }
}
.text-success {
  font-family: Lato;
  font-size: 18px;
  line-height: 26px;
  color: #0d0d0d;
  @media (max-width: 600px) {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
